











import Vue from 'vue'
import feather from 'feather-icons'

// Documentation: https://feathericons.com/
export default Vue.extend({
  name: "UiIcon",
  props: {
    icon: String,
    height: String,
    width: String,
    color: String,
  },
  computed: {
    getHeight(){
      return this.height || this.width || 14
    },
    getWidth(){
      return this.width || this.height || 14
    },
    getColor(){
      return this.color || '#2c3e50'
    },
  },
  data(){
    return {
      icons: feather.icons,
    }
  },
})
